import React, {forwardRef} from 'react'

import Input from '../Input'
import {IInputProps} from '../Input/Input'

interface IInputCvcProps extends IInputProps {}

const InputCvc = forwardRef<HTMLInputElement, IInputCvcProps>((props, ref) => {
	const {onChange} = props

	const onChangeCvc = (e: React.ChangeEvent<HTMLInputElement>) => {
		const value = e.target?.value
		const newValue = value.slice(0, 4)

		e.target.value = newValue
		onChange && onChange(e)
	}

	return <Input {...props} onChange={onChangeCvc} ref={ref} />
})

InputCvc.displayName = 'InputCvc'

export default InputCvc
